export default __webpack_public_path__ + "images/Transthalamic_View_dark.5427a8e08f463c394a5853d518696050.png";